export const NAMESPACE = "EventLightPassesSettingsDesigns";

export const FORM_ID = "EventLightPassesSettingsDesigns";

export const FIELD_IDS = {
  DESIGN_HTML: "design_html",
  WRAPPER_HTML: "wrapper_html",
  SETTINGS_JSON: "settings_json"
};
